module.exports = __webpack_public_path__ + "img/InfoHistory.d1bde52.jpg";